<script setup>
import {VueSignaturePad} from 'vue-signature-pad';
import FormButton from '@/components/Shared/Form/Button';
import {useForm} from "@inertiajs/vue3";
import {inject, ref} from "vue";
import Swal from "sweetalert2";
import VuePdfEmbed from 'vue-pdf-embed';

const trans = inject('trans');
const signaturePad = ref(null);

const props = defineProps({
  partner: {
    type: Object,
  },
  contract: {
    type: Object,
  }
});

const form = useForm({
  signature: null,
});

const save = () => {
  const {isEmpty, data} = signaturePad.value.saveSignature();

  if (isEmpty) {
    form.signature = null;

    return;
  }

  form.signature = data;

  form.post(route('partner.contract.store'), {
    preserveScroll: true,
    onSuccess: () => {
      form.reset();

      Swal.fire({
        text: trans('__JSON__.Welcome partner! We have just unlocked your Partner section in the menu'),
        icon: 'success',
        showConfirmButton: false,
        timer: 4000,
      });

    }
  });

};
</script>

<template>
  <div class="my-4 mx-8 pt-4 contract-wrapper">
    <div>
      <div v-if="contract.contract_base64">
        <vue-pdf-embed :source="contract.contract_base64"/>
      </div>
      <div v-if="!contract.contract_signature_base64" class="signature-pad-wrapper">
        <h2 class="h4 py-4">
          {{ trans('__JSON__.Sign Here') }}
        </h2>
        <div>
          <div>
            <form class="flex justify_start gap">
              <div class="wrapper border signature-pad w-3/5 min-w-1/2">
                <vue-signature-pad ref="signaturePad" height="100px"/>
              </div>
              <div>
                <form-button
                  type="button"
                  :processing="form.processing"
                  :value="trans('__JSON__.Submit')"
                  @click="save"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.pdf_pad iframe {
  background: transparent !important;
  height: 100%;
  width: 100%;
}

.signature-pad-wrapper {
  background-color: white;
  padding-left: 50px;
  margin-top: -25px;
  padding-bottom: 50px;
}

.signature-pad {
  cursor: crosshair;
}

.contract-wrapper {
  max-width: 1000px;
  max-height: 5000px;
}
</style>
